import { isActiveRoute, routeHref } from "../router";
import type { Route } from "../types";
import { esc } from "./toast";

const NAV = [
  { name: "read" as const, label: "阅读" },
  { name: "library" as const, label: "文库" },
  { name: "statistics" as const, label: "统计" },
  { name: "data" as const, label: "数据" },
  { name: "settings" as const, label: "设置" },
];

export function renderShell(route: Route, mainHtml: string): void {
  const app = document.getElementById("app");
  if (!app) {
    return;
  }

  const nav = NAV.map(
    (item) =>
      `<a href="${routeHref(item.name)}" class="topnav-link${isActiveRoute(route, item.name) ? " is-active" : ""}">${esc(item.label)}</a>`,
  ).join("");

  app.innerHTML = `
    <header class="topbar">
      <div class="topbar-inner">
        <a class="brand" href="${routeHref("read")}">
          <span class="brand-mark" aria-hidden="true"></span>
          <span class="brand-text">ReadThrough</span>
        </a>
        <nav class="topnav" aria-label="主导航">${nav}</nav>
      </div>
    </header>
    <main id="view" class="view">${mainHtml}</main>
    <footer class="site-footer">
      <p>数据只存在本机浏览器。清缓存或换电脑前，请先到 <a href="${routeHref("data", "export")}">数据</a> 页导出 Excel。 · <a href="https://no996.work/" rel="noopener">no996 主站</a></p>
    </footer>
  `;
}

export function getViewEl(): HTMLElement | null {
  return document.getElementById("view");
}
